export default {
  page: 'Strana',
  layoutSubtitle: 'Prázdne nastavenia sa preberajú zo základného rozloženia.',
  blocksSubtitle: 'Bloky sa v správe zobrazujú v tomto poradí. Blok presuniete potiahnutím za jeho úchyt.',
  resetBlocks: 'Použiť predvolené bloky správy',
};
